import { render } from "./AccessRequest.vue?vue&type=template&id=379637d2"
import script from "./AccessRequest.vue?vue&type=script&lang=js"
export * from "./AccessRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__